const { relativeTimeRounding } = require("moment");

window.onerror = function errorHandler(msg, url, line) {
    $("#status").fadeOut();
    $("#preloader")
        .delay(1000)
        .fadeOut("slow");
    return false;
};

window.breakpoints = {
    xs: { max: 767 },
    sm: { max: 991 },
    md: { max: 1199 },
    lg: { min: 1200 }
};

window.breakpoint = function(breakpoint) {
    if (
        (!breakpoints[breakpoint].min ||
            $(window).width() >= breakpoints[breakpoint].min) &&
        (!breakpoints[breakpoint].max ||
            $(window).width() <= breakpoints[breakpoint].max)
    ) {
        return true;
    }
    return false;
};

window.dtDefaultOptions = {
    mark: true,
    scrollX: true,
    language: {
        url: "/js/vendor/dataTables/lang/" + $("html").attr("lang") + ".json"
    },
    drawCallback: function(settings) {
        $(".dt-button", ".dataTables_wrapper").removeClass("dt-button");
    }
};

if (!breakpoint("xs")) {
    window.dtDefaultOptions.fixedColumns = {
        leftColumns: 1
    };
}

window.goToComments = function() {
    var hash = window.location.hash.substr(1);
    if (hash) {
        $(".comments." + hash).collapse("show", function() {
            console.log(hash);
            $("html, body").animate(
                {
                    scrollTop: $(".comments." + hash).offset().top - 200
                },
                1000
            );
        });
    }
};

$(document).ready(function() {
    // Toggle more dashboard filters
    $(".btn-more").on("click", function() {
        $(".more-filters").toggleClass("open");
        $(".arc-header").toggleClass("more");
    });

    // Mobile toggle menu
    $(".btn-header-mobile").on("click", function() {
        $(".arc-header").addClass("arc-header-open");
    });
    $(".close-header-mobile").on("click", function() {
        $(".arc-header").removeClass("arc-header-open");
    });

    // Accordion panel on edit mode
    $(".collapseSection").on("click", function() {
        $(this).toggleClass("open");
        $(this)
            .closest(".edit-panel")
            .find(".edit-panel-body")
            .toggleClass("open");
    });

    // Keep open sidebar on edit mode
    $(".arc-sidebar .edit, .arc-sidebar .add").on("click", function() {
        $(".arc-sidebar").addClass("open");
    });
    $(".arc-sidebar .view").on("click", function() {
        $(".arc-sidebar").removeClass("open");
    });

    // Toggle right-bar widgets
    $(".widget-content").delegate(".open-right-bar", "click", function(e) {
        e.preventDefault();
        $(".right-bar").removeClass("open");
        $(".open-right-bar").removeClass("active");
        $(this)
            .closest(".widget-box")
            .find(".right-bar")
            .addClass("open");
        $(this).addClass("active");
    });

    $(".close-right-bar-btn").on("click", function() {
        $(".right-bar").removeClass("open");
        $(".open-right-bar").removeClass("active");
    });

    // Toggle right-bar accordions
    $(".rb-title").on("click", function() {
        $(this)
            .siblings()
            .toggle();
    });

    $(function() {
        $('[data-toggle="popover"]').popover({ container: "body" });
    });

    setTimeout(function() {
        $(".widget-alert").hide();
    }, 10000);

    $(".widget-box").delegate(".widget-alert-close", "click", function() {
        $(this)
            .closest(".widget-alert")
            .hide();
    });

    if (breakpoint("sm")) {
    } else if (breakpoint("md")) {
        $(".sidebar-toggle").trigger("click");
    }

    $(".ajaxDataTable").each(function() {
        $(this).DataTable(
            $.extend(true, {}, window.dtDefaultOptions, {
                processing: true,
                serverSide: true,
                order: $(this).data("order")
                    ? $(this).data("order")
                    : [[0, "asc"]],
                ajax: $(this).data("end_point"),
                columns: $(this).data("columns"),
                drawCallback: function(settings) {
                    $(".dt-button", ".dataTables_wrapper").removeClass(
                        "dt-button"
                    );
                }
            })
        );
    });

    $(".clientDataTable").each(function() {
        $(this).dataTable($.extend(true, {}, window.dtDefaultOptions, {}));
    });

    $(document).on("init.dt", function(e, settings) {
        var api = new $.fn.dataTable.Api(settings);

        if (typeof window.route_mass_crud_entries_destroy != "undefined") {
            $(".clientDataTable, .ajaxDataTable")
                .siblings(".actions")
                .html(
                    '<a href="' +
                        window.route_mass_crud_entries_destroy +
                        '" class="js-delete-selected">' +
                        window.deleteButtonTrans +
                        "</a>"
                );
        }
    });

    $(document).on(
        "click",
        ".DTFC_LeftWrapper .dataTable tbody tr",
        function() {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
                $(this)
                    .closest(".dataTables_wrapper")
                    .find(".dataTables_scrollBody .dataTable tbody tr")
                    .eq($(this).index())
                    .removeClass("selected");
            } else {
                $(this).removeClass("selected");
                $(this).addClass("selected");
                $(this)
                    .closest(".dataTables_wrapper")
                    .find(".dataTables_scrollBody .dataTable tbody tr")
                    .eq($(this).index())
                    .addClass("selected");
            }
        }
    );

    $(document).on(
        "click",
        ".dataTables_scrollBody .dataTable tbody tr",
        function() {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
                $(this)
                    .closest(".dataTables_wrapper")
                    .find(".DTFC_LeftWrapper .dataTable tbody tr")
                    .eq($(this).index())
                    .removeClass("selected");
            } else {
                $(this).removeClass("selected");
                $(this).addClass("selected");
                $(this)
                    .closest(".dataTables_wrapper")
                    .find(".DTFC_LeftWrapper .dataTable tbody tr")
                    .eq($(this).index())
                    .addClass("selected");
            }
        }
    );

    $(document).on(
        "mouseover mouseout",
        ".DTFC_LeftWrapper .dataTable tbody tr",
        function() {
            if ($(this).hasClass("hovered")) {
                $(this).removeClass("hovered");
                $(this)
                    .closest(".dataTables_wrapper")
                    .find(".dataTables_scrollBody .dataTable tbody tr")
                    .eq($(this).index())
                    .removeClass("hovered");
            } else {
                $(this).removeClass("hovered");
                $(this).addClass("hovered");
                $(this)
                    .closest(".dataTables_wrapper")
                    .find(".dataTables_scrollBody .dataTable tbody tr")
                    .eq($(this).index())
                    .addClass("hovered");
            }
        }
    );

    $(document).on(
        "mouseover mouseout",
        ".dataTables_scrollBody .dataTable tbody tr",
        function() {
            if ($(this).hasClass("hovered")) {
                $(this).removeClass("hovered");
                $(this)
                    .closest(".dataTables_wrapper")
                    .find(".DTFC_LeftWrapper .dataTable tbody tr")
                    .eq($(this).index())
                    .removeClass("hovered");
            } else {
                $(this).removeClass("hovered");
                $(this).addClass("hovered");
                $(this)
                    .closest(".dataTables_wrapper")
                    .find(".DTFC_LeftWrapper .dataTable tbody tr")
                    .eq($(this).index())
                    .addClass("hovered");
            }
        }
    );

    $(document).on("click", ".data-table-delete-single", function(evt) {
        evt.preventDefault();
        var form = $(this).parent("form");
        swal({
            text: alertDeleteItemTrans,
            type: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            cancelButtonText: alertCancelButtonTrans,
            cancelButtonClass: "btn btn-default",
            confirmButtonText: alertDeleteButtonTrans,
            confirmButtonClass: "btn btn-danger"
        }).then(function(result) {
            if (result.value) {
                form.submit();
            }
        });
    });

    $(".select2-ajax").each(function() {
        var current = $(this);
        current.css("width", "100% !important");
        current.on("select2:select", function(e) {
            var data = e.params.data;
            if ($("[name=" + current.attr("name") + "-label]").length > 0) {
                $("[name=" + current.attr("name") + "-label]").val(data.text);
            }
        });
        current.select2({
            language: $("html").attr("lang"),
            ajax: {
                url: current.data("url"),
                dataType: "json",
                delay: 250,
                data: function(params) {
                    return {
                        needle: params.term // search term
                    };
                },
                processResults: function(data) {
                    var selectobj = $.map(data, function(v) {
                        return {
                            text: v[current.data("text_field")],
                            id: v[current.data("id_field")]
                                ? v[current.data("id_field")]
                                : v["id"]
                        };
                    });
                    return { results: selectobj };
                },
                cache: true,
                error: function(err) {}
            },
            placeholder: current.data("placeholder"),
            minimumInputLength: 2,
            allowClear: true
        });
    });

    $(".select2-rendered").each(function() {
        var current = $(this);
        current.select2({
            language: $("html").attr("lang"),
            allowClear: true,
            cache: true,
            debug: true,
            placeholder: current.data("placeholder")
        });
    });

    $(".select2-with-flag").each(function() {
        let current = $(this);
        current.select2({
            language: $("html").attr("lang"),
            allowClear: true,
            cache: true,
            debug: true,
            placeholder: current.data("placeholder"),
            templateResult: select2AddFlag,
            templateSelection: select2AddFlag
        });
    });

    $(".select2-with-logo").each(function() {
        let current = $(this);
        current.select2({
            language: $("html").attr("lang"),
            allowClear: true,
            cache: true,
            debug: true,
            placeholder: current.data("placeholder"),
            templateResult: select2AddLogo,
            templateSelection: select2AddLogo
        });
    });

    function select2AddFlag(opt) {
        let flag = $(opt.element).data("flag");

        if (!flag) {
            return opt.text;
        }

        return $(
            '<span><i class="flag-icon flag-icon-' +
                flag +
                '"></i>' +
                opt.text +
                "</span>"
        );
    }

    function select2AddLogo(opt) {
        let logoSrc = $(opt.element).data("logo-src");

        if (!logoSrc) {
            return $(
                '<span class="select2-with-flag__option-text">' +
                    opt.text +
                    "</span>"
            );
        }
        return $(
            '<img src="' +
                logoSrc +
                '" class="select2-with-logo__logo" style="max-width: 16px; height: autp;"><span class="select2-with-flag__option-text" style="margin-left: 4px;">' +
                opt.text +
                "</span>"
        );
    }

    $(".select2-selection__rendered").removeAttr("title");

    $(".editor").each(function(index, item) {
        ClassicEditor.create(document.querySelector("#" + $(item).attr("id")), {
            language: $("html").attr("lang"),
            toolbar: [
                "heading",
                "|",
                "bold",
                "italic",
                "link",
                "bulletedList",
                "numberedList",
                "blockQuote"
            ],
            heading: {
                options: [
                    {
                        model: "paragraph",
                        title: "Paragraph",
                        class: "ck-heading_paragraph"
                    },
                    {
                        model: "heading1",
                        view: "h1",
                        title: "Heading 1",
                        class: "ck-heading_heading1"
                    },
                    {
                        model: "heading2",
                        view: "h2",
                        title: "Heading 2",
                        class: "ck-heading_heading2"
                    }
                ]
            }
        }).catch(error => {
            console.error(error);
        });
    });

    moment.locale($("html").attr("lang"));

    $(".date-time-range-picker").each(function() {
        var current = $(this);
        var start_date = $("#" + current.attr("id") + "_start").val();
        var end_date = $("#" + current.attr("id") + "_end").val();

        var options = {
            timePicker: true,
            timePicker24Hour: true,
            timePickerIncrement: 1,
            locale: daterangepickerLocale
        };

        if (start_date && end_date) {
            options.startDate = start_date;
            options.endDate = end_date;
        }

        current.daterangepicker(options, function(start, end, label) {
            $("#" + current.attr("id") + "_start").val(
                start.format("DD/MM/YYYY HH:mm")
            );
            $("#" + current.attr("id") + "_end").val(
                end.format("DD/MM/YYYY HH:mm")
            );
        });
    });

    $(".date-picker").each(function() {
        var current = $(this);
        var locale = $.extend(true, {}, daterangepickerLocale, {
            format: "DD/MM/YYYY"
        });
        current.daterangepicker(
            {
                singleDatePicker: true,
                autoUpdateInput: false,
                showDropdowns: true,
                locale: locale
            },
            function(start, end, label) {
                $("#" + current.data("field")).val(start.format("DD/MM/YYYY"));
                current.val(start.format("DD/MM/YYYY"));
            }
        );
    });

    $(".file-upload").each(function() {
        $(this).on("change", function() {
            var files = $(this).prop("files");
            var attachmentsPreviewContainer = $(
                "." + $(this).data("preview-container")
            );
            attachmentsPreviewContainer.empty();
            $.map(files, function(val) {
                var previewFileItem =
                    '<li class="list-group-item" data-name="' +
                    val.name +
                    '">' +
                    val.name +
                    "</li>";
                $(attachmentsPreviewContainer).append(previewFileItem);
            });
        });
    });

    $(".ios-checkbox").iosCheckbox();

    $('.widget-option .icon.fa-info-circle').tooltip({
        tooltipClass: "no-bold",
    });

    $(document).on("click", "#save_widget_owner", function(evt) {
        widget_id = $(this).prev().find('select[name=select-widget-owner]').attr('widget_id');
        owner_id = $(this).prev().find('select[name=select-widget-owner] option').filter(':selected').val();
        $.ajax("/widget/setOwnership", {
            method: "POST",
            headers: {
                "X-CSRF-TOKEN": window._token
            },
            data: {
                widget_id: widget_id,
                owner_id: owner_id 
            },
            success: function(res) {
                /*$(".close-right-bar-btn").trigger('click');
                swal({
                    text: "Widget assegnato con successo!",
                    timer: 3000
                });*/
                location.reload();
            },
            error: function(err, a, b) {
                alert("Not Saved");
            }
        });
    });

});

$(window).on("load", function() {
    new WOW.WOW({ mobile: false }).init();

    $("#status").fadeOut();
    $("#preloader").fadeOut("slow");
});



// WEBPACK FOOTER //
// ./resources/js/global.js